// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f5b7430e","455":"9c6f3aab","488":"288687f5","977":"1de080df"}[chunkId] + ".chunk.js";
};